import Header from './components/Header';
import HeroSection from './components/HeroSection';
import UpdatesSection from './components/UpdatesSection';
import RankingSection from './components/RankingSection';
import CommentsSection from './components/CommentsSection';
import AboutSection from './components/AboutSection';
import AppSection from './components/AppSection';
import CardsSection from './components/CardsSection';
import FaqSection from './components/FaqSection';
import ContactSection from './components/ContactSection';
import MediaSection from './components/MediaSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import IndexSection from './components/IndexSection';
import FeaturesSection from './components/FeaturesSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 text-foreground-100">
      <Header />

      <main>
        <HeroSection />
        <UpdatesSection />
        <RankingSection />
        <CommentsSection />
        <AboutSection />
        <AppSection />
        <CardsSection />
        <FaqSection />
        <ContactSection />
        <MediaSection />
        <CarouselSection />
        <TopicsSection />
        <IndexSection />
        <FeaturesSection />
      </main>

      <Footer />
    </div>
  );
}